import * as types from '../mutation-types'
import axios from "axios";

// state
export const state = {
    expired: []
};

// getters
export const getters = {
    expired: state => state.expired
};

// mutations
export const mutations = {
    [types.REMINDERS_EXPIRED_SET] (state, data) {
        state.expired = data;
    }
};

// actions
export const actions = {
    async fetchExpired(context) {
        await axios.get('/api/request_reminders/user/expired')
            .then(function (response) {
                context.commit(types.REMINDERS_EXPIRED_SET, response.data)
            });
    }
};
